import { DefaultButton, getTheme, Label, Modal, Stack, Text } from '@fluentui/react';
import React from 'react';
import { useWindowWidth } from 'shared-state/display-options/hooks';
import { IImagePickerImage } from '../ImagePicker.state';
import ImagePickerModal from './ImagePickerModal';

interface IVisitorEntranceImagePickerViewProps {
    onDismiss: () => void;
    modalIsOpen: boolean;
    selectedImage: IImagePickerImage;
    imageOptions: IImagePickerImage[];
    onImageSelect: (i: IImagePickerImage) => void;
    onFile: (f: any) => void;
    onModalOpen: () => void;
    onDiscardImage: (f: string) => void;
    label?: string;
    buttonText?: string;
    callout?: string;
    imageThumbnail?: string;
}

const getBackgroundImage = (selectedImage: { url: string }, imageThumbnail?: string) => {
    if (imageThumbnail === undefined) return 'none';
    return selectedImage.url === '' || selectedImage.url === 'none' ? `url('${imageThumbnail}')` : `url('${selectedImage.url}')`;
};

const VisitorEntranceImagePickerView: React.FC<IVisitorEntranceImagePickerViewProps> = ({
    onModalOpen,
    onDismiss,
    imageOptions,
    modalIsOpen,
    selectedImage,
    onImageSelect,
    onFile,
    label,
    onDiscardImage,
    buttonText,
    callout,
    imageThumbnail
}) => {
    const theme = getTheme();
    const { smallDevice } = useWindowWidth();

    return (
        <>
            {label && <Label style={{}}>{label}</Label>}
            <Stack style={{ marginBottom: '10px' }}>
                <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 32 }}>
                    <Stack
                        aria-label={'backgroundImagePickerPanel'}
                        onClick={onModalOpen}
                        horizontalAlign="center"
                        verticalAlign="center"
                        style={{
                            width: '407px',
                            height: '127px',
                            backgroundImage: getBackgroundImage(selectedImage, imageThumbnail),
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            cursor: 'pointer'
                        }}
                    />

                    {!smallDevice && (
                        <Stack>
                            <Text style={{ marginLeft: 'auto', width: '410px', marginBottom: '40px' }}>{callout}</Text>
                            <Stack style={{ flexDirection: 'column', marginLeft: 'auto', width: '36%' }}>
                                <DefaultButton text={buttonText} iconProps={{ iconName: 'edit' }} onClick={onModalOpen}></DefaultButton>
                            </Stack>
                        </Stack>
                    )}
                </Stack>

                <Modal isOpen={modalIsOpen} onDismiss={onDismiss}>
                    <ImagePickerModal
                        {...{
                            onDismiss,
                            selectedImage,
                            imageOptions,
                            onImageSelect,
                            onFile,
                            onDiscardImage,
                            theme,
                            smallDevice
                        }}
                    />
                </Modal>
            </Stack>
        </>
    );
};

export default VisitorEntranceImagePickerView;
